import React, { useState } from 'react';
import { 
  Clock, Users, Calendar, FileText, CheckCircle2, Circle, AlertCircle, Download 
} from 'lucide-react';
import { Modal, DatePicker, Button, message } from 'antd';
import * as XLSX from 'xlsx';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const RightSidebar = ({ overview = {}, todaysSchedule = [], onEventClick,quickStats,events = [] }) => {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState([]);

  const stats = [
  { 
    label: 'Pending Approvals', 
    value: overview.pendingApprovals ?? 0,
    icon: <AlertCircle className="w-4 h-4 text-orange-400" />,
    color: 'orange'
  },
  { 
    label: 'Active Appointments', 
    value: overview.activeAppointments ?? 0,
    icon: <Users className="w-4 h-4 text-green-400" />,
    color: 'green'
  },
  { 
    label: 'This Month Events', 
    value: overview.thisMonthEvents ?? 0,
    icon: <Calendar className="w-4 h-4 text-purple-400" />,
    color: 'purple'
  },
  { 
    label: 'Total Visits', 
    value: overview.totalVisits ?? 0,
    icon: <FileText className="w-4 h-4 text-blue-400" />,
    color: 'blue'
  }
];

  const getScheduleStatus = (status) => {
    switch (status) {
      case 'completed':
        return <CheckCircle2 className="w-4 h-4 text-green-400" />;
      case 'ongoing':
        return <Circle className="w-4 h-4 text-yellow-400 fill-current" />;
      case 'upcoming':
        return <Clock className="w-4 h-4 text-blue-400" />;
      default:
        return <Clock className="w-4 h-4 text-gray-400" />;
    }
  };

  // const handleDownload = () => {
  //   if (!dateRange || dateRange.length !== 2) {
  //     message.warning('Please select a valid date range');
  //     return;
  //   }

  //   const [start, end] = dateRange;
  //   const filtered = events.filter(e => {
  //     const createdAt = new Date(e.createdAt);
  //     return createdAt >= start.toDate() &&
  //            createdAt <= end.toDate() &&
  //            e.status !== 'cancelled';
  //   });

  //   if (filtered.length === 0) {
  //     message.info('No events found in the selected range');
  //     return;
  //   }

  //   const csvData = filtered.map((e, index) => {
  // let dynamicTypeLabel = '';

  // if (e.typeOfEvent === 'visit') {
  //   dynamicTypeLabel = 'Visitor Type';
  // } else if (e.typeOfEvent === 'invitation') {
  //   dynamicTypeLabel = 'Invitation Type';
  // } else if (e.typeOfEvent === 'appointment') {
  //   dynamicTypeLabel = 'Appointment Type';
  // }

  // return {
  //   "S.No": index + 1,
  //   "Event Title": e.eventTitle,
  //   "Name": `${e.firstName || ''} ${e.lastName || ''}`.trim(),
  //   "Phone Number": e.phone || '',
  //   "Type of Event": e.typeOfEvent.charAt(0).toUpperCase() + e.typeOfEvent.slice(1)|| '',
  //   "Date": dayjs(e.start).format('YYYY-MM-DD'),
  //   "Start Time": dayjs(e.start).format('HH:mm'),
  //   "End Time": dayjs(e.end).format('HH:mm'),
  //   "Status": e.status.charAt(0).toUpperCase() + e.status.slice(1)|| '',
  //   "Address":e?.address || '',
  //   [dynamicTypeLabel]: e.visitorType || '',  // dynamic column key
  //   "Office": e?.office || '',
  //   "Purpose": e?.description || '',
  //   "Submitted By": e.createdByUserName,
  //   "Created At":dayjs(e.createdAt).format('YYYY-MM-DD')
  // };
  // });

  //   const worksheet = XLSX.utils.json_to_sheet(csvData, { origin: 'A1' });
  //   // Styling for bold headers (XLSX format)
  //    const range = XLSX.utils.decode_range(worksheet['!ref']);
  //    for (let C = range.s.c; C <= range.e.c; ++C) {
  //     const cell_address = XLSX.utils.encode_cell({ c: C, r: 0 });
  //     if (!worksheet[cell_address]) continue;
  //     worksheet[cell_address].s = {
  //       font: { bold: true }
  //     };
  //   }
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Events');
  //   XLSX.writeFile(workbook, `Events_${start.format('YYYYMMDD')}_${end.format('YYYYMMDD')}.csv`);

  //   setIsExportModalOpen(false);
  //   setDateRange([]);
  // };

  const handleDownload = () => {
  if (!dateRange || dateRange.length !== 2) {
    message.warning('Please select a valid date range');
    return;
  }

  const [start, end] = dateRange;
  const filtered = events.filter(e => {
    const createdAt = new Date(e.createdAt);
    return (
      createdAt >= start.toDate() &&
      createdAt <= end.toDate() &&
      e.status !== 'cancelled'
    );
  });

  if (filtered.length === 0) {
    message.info('No events found in the selected range');
    return;
  }

  // Prepare data
  const headerRow = [
    "S.No", "Event Title", "Name", "Phone Number", "Type of Event",
    "Date", "Start Time", "End Time", "Status", "Address",
    "Visitor Type / Invitation Type / Appointment Type",
    "Office", "Purpose", "Submitted By"
  ];

  const rows = filtered.map((e, index) => {
    let dynamicType = e.visitorType || '';
    if (e.typeOfEvent === 'visit') dynamicType = e.visitorType || '';
    if (e.typeOfEvent === 'invitation') dynamicType = e.visitorType || '';
    if (e.typeOfEvent === 'appointment') dynamicType = e.visitorType || '';

    return [
      index + 1,
      e.eventTitle || '',
      `${e.firstName || ''} ${e.lastName || ''}`.trim(),
      e.phone || '',
      e.typeOfEvent.charAt(0).toUpperCase() + e.typeOfEvent.slice(1)|| '',
      dayjs(e.start).format('YYYY-MM-DD'),
      dayjs(e.start).format('HH:mm'),
      dayjs(e.end).format('HH:mm'),
      e.status.charAt(0).toUpperCase() + e.status.slice(1)|| '',
      e?.address || '',
      dynamicType,
      e?.office || '',
      e?.description || '',
      e?.createdByUserName || ''
    ];
  });

  const sheetData = [headerRow, ...rows];

  const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

  // Bold header row
  headerRow.forEach((_, i) => {
    const cellRef = XLSX.utils.encode_cell({ r: 0, c: i });
    if (!worksheet[cellRef]) return;
    worksheet[cellRef].s = {
      font: { bold: true }
    };
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Events');
  XLSX.writeFile(workbook, `Events_${start.format('YYYYMMDD')}_${end.format('YYYYMMDD')}.xlsx`);

  setIsExportModalOpen(false);
  setDateRange([]);
};

  return (
    <div className="h-full space-y-6">
      {/* Stats Grid */}
      <div className="grid grid-cols-2 gap-3 ">
        {stats.map((stat, index) => (
          <div key={index} className="flex flex-col shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] text-black p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50">
            <div className="flex items-center space-x-2 mb-2">
              <div className={`p-1 bg-${stat.color}-500/20 rounded-md`}>
                {stat.icon}
              </div>
              <div className="text-2xl font-bold text-gray-800">{stat.value}</div>
            </div>
            <div className="text-xs text-gray-600 mb-1">{stat.label}</div>
            <div className="text-xs text-gray-500">{stat.change}</div>
          </div>
        ))}
      </div>

      {/* Today's Schedule */}
      <div className="flex flex-col shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] text-black p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-800">Today's Schedule</h3>
          <Clock className="w-5 h-5 text-gray-600" />
        </div>
        <div className="space-y-3">
          {todaysSchedule.length > 0 ? (
            todaysSchedule.sort((a, b) => new Date(a.start) - new Date(b.start)).map((item) => (
              <div
                key={item._id}
                className="flex items-center space-x-3 p-3 bg-white/10 backdrop-blur-sm rounded-lg hover:bg-white/20 transition-all duration-200 border border-white/20 shadow-md cursor-pointer hover:scale-[1.01] hover:shadow-xl hover:border-blue-300/40"
                onClick={() => onEventClick(item._id)}
              >
                <div className="flex-shrink-0 pt-1">
                    <span
                      className={`inline-block w-3 h-3 rounded-full ${
                        item.typeOfEvent === 'appointment'
                          ? 'bg-blue-500'
                          : item.typeOfEvent === 'invitation'
                          ? 'bg-purple-500'
                          : item.typeOfEvent === 'visit'
                          ? 'bg-green-500'
                          : 'bg-gray-400'
                      }`}
                    ></span>
                  </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-700 truncate">{item.eventTitle} ({item.typeOfEvent.charAt(0).toUpperCase() + item.typeOfEvent.slice(1)})</p>
                  <p className="text-xs text-gray-600">
                    {new Date(item.start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} -{' '}
                    {new Date(item.end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </p>
                </div>
                <div className="flex-shrink-0">
                  {getScheduleStatus(item.status)}
                </div>
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-600">No scheduled events today.</p>
          )}
        </div>
      </div>

      {/* Quick Stats */}
      <div className="flex flex-col shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] text-black p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Quick Stats</h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="p-2 backdrop-blur-sm rounded-lg border border-blue-200/40">
                <Calendar className="w-4 h-4 text-blue-400" />
              </div>
              <div>
                <p className="text-sm text-gray-800">Events This Week</p>
                <p className="text-xs text-gray-600">{quickStats?.eventsThisWeek} scheduled</p>
              </div>
            </div>
            <span className="text-lg font-bold text-gray-700">{quickStats?.eventsThisWeek}</span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="p-2 backdrop-blur-sm rounded-lg border border-green-200/40">
                <Users className="w-4 h-4 text-green-400" />
              </div>
              <div>
                <p className="text-sm text-gray-800">Team Members</p>
                <p className="text-xs text-gray-600">{quickStats?.teamMembers} online now</p>
              </div>
            </div>
            <span className="text-lg font-bold text-gray-700">{quickStats?.teamMembers}</span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="p-2 backdrop-blur-sm rounded-lg border border-purple-200/40">
                <CheckCircle2 className="w-4 h-4 text-purple-400" />
              </div>
              <div>
                <p className="text-sm text-gray-800">Total Active Events</p>
                <p className="text-xs text-gray-600">{quickStats?.totalActiveEvents}</p>
              </div>
            </div>
            <span className="text-lg font-bold text-gray-700">{quickStats?.totalActiveEvents}</span>
          </div>
        </div>
      </div>
      
      {/* Export Button */}
      <div className="">
        <button
          className="flex items-center justify-center space-x-2 w-full py-2 px-3 text-white rounded-xl shadow-lg transition-all duration-300 transform hover:scale-[1.02] hover:shadow-xl font-medium"
          style={{ 
            backgroundColor: 'var(--polstrat-primary)',
            border: '1px solid var(--polstrat-primary)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#003558';
            e.target.style.borderColor = '#003558';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'var(--polstrat-primary)';
            e.target.style.borderColor = 'var(--polstrat-primary)';
          }}
          onClick={() => setIsExportModalOpen(true)}
        >
          <Download className="w-5 h-5" />
          <span className='font-semibold'>Export Events</span>
        </button>
      </div>
    {/* Export Modal */}
      <Modal
        title="Select Date Range for Download"
        open={isExportModalOpen}
        onCancel={() => setIsExportModalOpen(false)}
        onOk={handleDownload}
        okText="Download"
        cancelText="Cancel"
      >
        <p className="text-gray-600 mb-2">Select the date range for which you want to download event details:</p>
        <RangePicker
          className="w-full"
          onChange={(range) => setDateRange(range)}
          placeholder={['Start Date', 'End Date']}
        />
      </Modal>
    </div>
  );
};

export default RightSidebar;
